import { HStack, TagRightIcon, TagLabel, Tag, LinkBox, LinkOverlay } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@heroicons/react/outline';

import React from 'react';

const QuestionDocuments = ({ documents }) => {
  return (
    <HStack>
      {
        documents.map(({ id, filename, url }) => (
          <LinkBox
            key={id}
          >
            <LinkOverlay
              data-test-id={`document-${id}`}
              href={url}
              target="_blank"
            >
              <Tag
                borderRadius="full"
                variant="solid"
              >
                <TagLabel>{filename}</TagLabel>
                <TagRightIcon as={ExternalLinkIcon} />
              </Tag>
            </LinkOverlay>
          </LinkBox>
        ))
      }
    </HStack>
  )
}

export default React.memo(QuestionDocuments);
